import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        backgroundColor: "#0E0E0E",          // fundo principal do modal
        color: "white",                      // texto branco
        borderRadius: 10,
        border: "1px solid #1EFF86",         // borda estilizada opcional
        boxShadow: "0 0 25px rgba(0,0,0,0.6)",
    },

    "& .MuiDialogTitle-root": {
        backgroundColor: "#111",
        color: "white",
        borderBottom: "1px solid #222",
    },

    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
        backgroundColor: "#0E0E0E",
        color: "white",
    },

    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
        backgroundColor: "#0E0E0E",
        borderTop: "1px solid #222",
    }
}));


export default function Modal(props) {

    const handleClose = () => {
        props.setOpen(false);
    };

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                open={props.open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    Sucesso!!!
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        Seu formulário foi enviado com sucesso. Em breve, entraremos em contato!
                    </Typography>
                    <Typography gutterBottom mt={2} mb={2}>
                        Estamos animados para conversar com você e explorar como podemos colaborar para alcançar
                        seus objetivos. Fique à vontade para nos fornecer qualquer informação adicional que considere
                        relevante. Agradecemos por considerar nossos serviços.
                    </Typography>
                    <Typography gutterBottom mt={3} mb={2}>
                        Enquanto isso, sinta-se à vontade para navegar pelo nosso site
                        e conhecer mais sobre o que oferecemos.
                    </Typography>
                    <Button
                        sx={{
                            backgroundColor: "#1EFF86",
                            borderRadius: "17px 0 17px 0",
                            fontSize: "0.9rem",
                            fontWeight: 800,
                            width: "100%",
                            py: 1.2,
                            color: "#000",
                            transition: "0.3s",
                            '&:hover': {
                                backgroundColor: "#9C01B9",
                                boxShadow: "0 4px 12px #9C01B9",
                            }
                        }}
                        autoFocus onClick={() => window.open("https://contblack.com.br/", "_blank")}>
                        Acessar site contblack
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: "#1EFF86",
                            borderRadius: "17px 0 17px 0",
                            fontSize: "0.9rem",
                            fontWeight: 800,
                            width: "120px",
                            py: 1.2,
                            color: "#000",
                            transition: "0.3s",
                            '&:hover': {
                                backgroundColor: "#9C01B9",
                                boxShadow: "0 4px 12px #9C01B9",
                            }
                        }}
                        autoFocus onClick={handleClose}>
                        Fechar
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}